import { FlaskConical, Gem, ScrollText } from "lucide-react";
import MenuIconBadge from "./MenuIconBadge";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_COLLECTION_TOOLTIPS } from "../constants/menuTooltips";

export default function MenuCollectionNav({
  activeTab = "gems",
  onTabChange = () => {},
  visible = true,
  cloverRewardsUnread = 0,
}) {
  if (!visible) return null;

  return (
    <div className="menuFilterContainer menuCollectionNavContainer">
      <MenuIconTooltip
        tooltip={MENU_COLLECTION_TOOLTIPS.gems}
        placement="left"
        portal
        className={activeTab === "gems" ? "filterIcon active" : "filterIcon"}
      >
        <Gem
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onTabChange("gems")}
          aria-label="Collection de gemmes"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_COLLECTION_TOOLTIPS.potions}
        placement="left"
        portal
        className={activeTab === "potions" ? "filterIcon active" : "filterIcon"}
      >
        <span className="menu-icon-badge-wrap">
          <FlaskConical
            size={50}
            color="#39210d"
            strokeWidth={1}
            onClick={() => onTabChange("potions")}
            aria-label="Catalogue des potions"
            style={{ cursor: "pointer" }}
          />
          <MenuIconBadge count={cloverRewardsUnread} />
        </span>
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_COLLECTION_TOOLTIPS.keys}
        placement="left"
        portal
        className={activeTab === "keys" ? "filterIcon active" : "filterIcon"}
      >
        <ScrollText
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onTabChange("keys")}
          aria-label="Parchemins de pouvoir"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
